import React from 'react';
import { call, put, takeLatest } from 'redux-saga/effects';

import { captureException } from '../../../client/sentry';
import { graphql } from '../../../globals/api/requests';
import { promptToast } from '../../../components/toast-container/actions';
import actions, {
  REMOVE_ALERT_REQUEST,
  RESTORE_ALERT_REQUEST,
} from '../actions/alert';
import Undo from '../undo';

export function* removeAlertRequest({ id, productId, onSuccess }) {
  try {
    const response = yield call(
      graphql,
      `mutation alertDelete($id: Int!) {
        alertDelete(id: $id) {
          restoreToken
        }
      }`,
      {
        id,
      }
    );

    if (response.errors) {
      yield put(actions.removeAlertError(response.errors[0]));
      return;
    }

    const { restoreToken } = response.data.alertDelete;

    yield put(actions.removeAlertSuccess(restoreToken, id, productId));
    if (onSuccess) {
      yield call(onSuccess);
    }
    yield put(
      promptToast(
        'success',
        <React.Fragment>
          {window.APP_GLOBALS.t('alerts', 'confirm.alert-deleted')}
          <Undo
            undo={actions.restoreAlertRequest(restoreToken, id, productId)}
          />
        </React.Fragment>,
        {
          toastId: productId,
        }
      )
    );
  } catch (err) {
    yield call(captureException, err);
    yield put(actions.removeAlertError(err));
  }
}

export function* restoreAlertRequest({ restoreToken, id, productId }) {
  try {
    const response = yield call(
      graphql,
      `mutation restoreItem($token: String!) {
        restoreItem(token: $token) {
          success
        }
      }`,
      {
        token: restoreToken,
      }
    );

    if (response.errors) {
      yield put(actions.restoreAlertError(response.errors[0]));
      return;
    }

    yield put(actions.restoreAlertSuccess(id, restoreToken));

    yield put(
      promptToast(
        'success',
        window.APP_GLOBALS.t('alerts', 'confirm.alert-restored'),
        {
          toastId: productId,
        }
      )
    );
  } catch (err) {
    yield call(captureException, err);
    yield put(actions.restoreAlertError(err));
  }
}

function* mySaga() {
  yield takeLatest(REMOVE_ALERT_REQUEST, removeAlertRequest);
  yield takeLatest(RESTORE_ALERT_REQUEST, restoreAlertRequest);
}

export default mySaga;
